import { useFormContext } from "react-hook-form";

import { FormValues } from "../new-employee-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form/form";
import { HelperButton } from "@/components/ui/helper-button/helper-button";
import { Input } from "@/components/ui/input/input";
import { Textarea } from "@/components/ui/textarea/textarea";

interface NewEmployeeAddressContactsProps {
  isPending: boolean;
}

// ? TAB Address & Contacts Schema
// ! phone: String,
// ! emergencyContactNumber: Number,
// ! address: String,
// ? TAB Address & Contacts Schema

export const NewEmployeeAddressContacts = ({
  isPending,
}: NewEmployeeAddressContactsProps) => {
  const form = useFormContext<FormValues>();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Phone
              <HelperButton>
                <p>Phone number of the Employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="text" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="emergencyContactNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Emergency Contact Number
              <HelperButton>
                <p>Emergency contact number for the employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="text" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="address"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Address
              <HelperButton>
                <p>Address of Employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Textarea rows={5} {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
